import { render, staticRenderFns } from "./OrderRemind.vue?vue&type=template&id=4d520452&scoped=true&"
import script from "./OrderRemind.vue?vue&type=script&lang=js&"
export * from "./OrderRemind.vue?vue&type=script&lang=js&"
import style0 from "./OrderRemind.vue?vue&type=style&index=0&id=4d520452&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d520452",
  null
  
)

export default component.exports